var _g, _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _path3, _linearGradient4, _path4, _linearGradient5, _path5, _linearGradient6, _path6, _linearGradient7, _path7, _linearGradient8, _path8, _linearGradient9, _path9, _linearGradient10, _path10, _g2, _g3, _g4, _g5, _g6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrazzers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 686 131.7"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#4D4D4D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M674.9 103.4c0 8.2-14.7 14.8-32.9 14.8H42.5c-18.2 0-32.9-6.6-32.9-14.8V21.1c0-8.2 14.7-14.8 32.9-14.8H642c18.2 0 32.9 6.6 32.9 14.8v82.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.8.5H15.2C7.4.5 1 7.1 1 15.3V117c0 8.2 6.4 14.8 14.2 14.8h656.5c7.9 0 14.2-6.6 14.2-14.8V15.3C686 7.1 679.6.5 671.8.5zm-4.9 95.6c0 8.2-6.4 14.8-14.2 14.8H34.3c-7.9 0-14.2-6.6-14.2-14.8V35c0-8.2 6.4-14.8 14.2-14.8h618.4c7.9 0 14.2 6.6 14.2 14.8v61.1z"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "brazzers_svg__a",
    gradientUnits: "userSpaceOnUse",
    x1: 339.793,
    y1: 5.587,
    x2: 339.793,
    y2: 113
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#brazzers_svg__a)",
    d: "M671 98.8c0 7.8-14.7 14.2-32.8 14.2H41.4c-18.1 0-32.8-6.3-32.8-14.2v-79C8.6 12 23.3 5.6 41.4 5.6h596.9c18.1 0 32.8 6.3 32.8 14.2v79z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "brazzers_svg__b",
    gradientUnits: "userSpaceOnUse",
    x1: 341,
    y1: -4,
    x2: 341,
    y2: 96
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#brazzers_svg__b)",
    d: "M667.8 0H14.2C6.3 0 0 6.3 0 14.2v97.7c0 7.8 6.3 14.2 14.2 14.2h653.7c7.8 0 14.2-6.3 14.2-14.2V14.2C682 6.3 675.7 0 667.8 0zM663 91.8c0 7.8-6.3 14.2-14.2 14.2H33.2C25.3 106 19 99.7 19 91.8V33.2C19 25.3 25.3 19 33.2 19h615.7c7.8 0 14.2 6.3 14.2 14.2v58.6z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "brazzers_svg__c",
    gradientUnits: "userSpaceOnUse",
    x1: 62.662,
    y1: 43,
    x2: 62.662,
    y2: 74
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#brazzers_svg__c)",
    d: "M84.9 33.8l-52.8-.1v29.4h52.8V63c4.6-.6 8.3-6.9 8.3-14.6 0-7.7-3.7-14-8.3-14.6zm-7.8 22.3H44.9v-12h32.2c2.8.2 5 2.8 5 6s-2.2 5.8-5 6z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "brazzers_svg__d",
    gradientUnits: "userSpaceOnUse",
    x1: 62.662,
    y1: 43,
    x2: 62.662,
    y2: 74
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#brazzers_svg__d)",
    d: "M84.9 62.8l-52.8-.1v29.4h52.8V92c4.6-.6 8.3-6.9 8.3-14.6 0-7.7-3.7-14-8.3-14.6zm-7.8 16.3H44.9v-12h32.2c2.8.2 5 2.8 5 6s-2.2 5.8-5 6z"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "brazzers_svg__e",
    gradientUnits: "userSpaceOnUse",
    x1: 211.601,
    y1: 43,
    x2: 211.601,
    y2: 74
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#brazzers_svg__e)",
    d: "M202.5 90.3h-11.7L220.7 34h11.7z"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "brazzers_svg__f",
    gradientUnits: "userSpaceOnUse",
    x1: 243.219,
    y1: 43,
    x2: 243.219,
    y2: 74
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#brazzers_svg__f)",
    d: "M252.3 90.3h11.8l-30-56.3h-11.7z"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "brazzers_svg__g",
    gradientUnits: "userSpaceOnUse",
    x1: 228.421,
    y1: 43,
    x2: 228.421,
    y2: 74
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#brazzers_svg__g)",
    d: "M208.1 67.9h40.6v10.4h-40.6z"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "brazzers_svg__h",
    gradientUnits: "userSpaceOnUse",
    x1: 308.268,
    y1: 41.109,
    x2: 308.268,
    y2: 96.1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f19300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#ffec00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f19300"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#brazzers_svg__h)",
    d: "M290 90.5h-16.6l53.1-57.3h16.6z"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "brazzers_svg__i",
    gradientUnits: "userSpaceOnUse",
    x1: 307.239,
    y1: 42,
    x2: 307.239,
    y2: 96
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f19300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#ffec00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f19300"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#brazzers_svg__i)",
    d: "M281.8 33.2h51v10.9h-51z"
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "brazzers_svg__j",
    gradientUnits: "userSpaceOnUse",
    x1: 310.459,
    y1: 42,
    x2: 310.459,
    y2: 96
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f19300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#ffec00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f19300"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#brazzers_svg__j)",
    d: "M283.7 79.7h53.5v10.9h-53.5z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "brazzers_svg__k",
    gradientUnits: "userSpaceOnUse",
    x1: 380.668,
    y1: 41.077,
    x2: 380.668,
    y2: 96.104
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f19300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#ffec00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f19300"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#brazzers_svg__k)",
    d: "M362.5 90.5h-16.6l52.9-57.3h16.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brazzers_svg__l",
    gradientUnits: "userSpaceOnUse",
    x1: 379.757,
    y1: 42,
    x2: 379.757,
    y2: 96
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f19300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#ffec00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f19300"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#brazzers_svg__l)",
    d: "M354.3 33.2h51v10.9h-51z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brazzers_svg__m",
    gradientUnits: "userSpaceOnUse",
    x1: 382.978,
    y1: 42,
    x2: 382.978,
    y2: 96
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f19300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#ffec00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f19300"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#brazzers_svg__m)",
    d: "M356.2 79.7h53.5v10.9h-53.5z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "brazzers_svg__n",
    gradientUnits: "userSpaceOnUse",
    x1: 457.878,
    y1: 43,
    x2: 457.878,
    y2: 74
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#brazzers_svg__n)",
    d: "M429.3 34.3h57.1v10.4h-57.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brazzers_svg__o",
    gradientUnits: "userSpaceOnUse",
    x1: 434.5,
    y1: 42.172,
    x2: 434.5,
    y2: 73.172
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#brazzers_svg__o)",
    d: "M429.3 34.2h10.4v56.1h-10.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brazzers_svg__p",
    gradientUnits: "userSpaceOnUse",
    x1: 457.878,
    y1: 43,
    x2: 457.878,
    y2: 74
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#brazzers_svg__p)",
    d: "M429.3 80.8h57.1v10.4h-57.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brazzers_svg__q",
    gradientUnits: "userSpaceOnUse",
    x1: 448.639,
    y1: 43,
    x2: 448.639,
    y2: 74
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#brazzers_svg__q)",
    d: "M429.3 55.6h38.6V66h-38.6z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "brazzers_svg__r",
    gradientUnits: "userSpaceOnUse",
    x1: 117.611,
    y1: 43,
    x2: 117.611,
    y2: 74
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#brazzers_svg__r)",
    d: "M111.4 59h12.5v32.2h-12.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brazzers_svg__s",
    gradientUnits: "userSpaceOnUse",
    x1: 152.816,
    y1: 43,
    x2: 152.816,
    y2: 74
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#brazzers_svg__s)",
    d: "M178 91.2h-16.7l-33.6-28h16.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brazzers_svg__t",
    gradientUnits: "userSpaceOnUse",
    x1: 142.88,
    y1: 43,
    x2: 142.88,
    y2: 74
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#brazzers_svg__t)",
    d: "M165.9 33.7l-54.5-.1v32.2h54.5v-.1c4.8-.6 8.5-7.6 8.5-16 0-8.5-3.8-15.4-8.5-16zm-11.1 24h-32.2v-12h32.2c2.8.2 5 2.8 5 6 0 3.1-2.2 5.7-5 6z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "brazzers_svg__u",
    gradientUnits: "userSpaceOnUse",
    x1: 511.611,
    y1: 43,
    x2: 511.611,
    y2: 74
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#brazzers_svg__u)",
    d: "M505.4 59h12.5v32.2h-12.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brazzers_svg__v",
    gradientUnits: "userSpaceOnUse",
    x1: 546.816,
    y1: 43,
    x2: 546.816,
    y2: 74
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#brazzers_svg__v)",
    d: "M572 91.2h-16.7l-33.6-28h16.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brazzers_svg__w",
    gradientUnits: "userSpaceOnUse",
    x1: 536.88,
    y1: 43,
    x2: 536.88,
    y2: 74
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#brazzers_svg__w)",
    d: "M559.9 33.7l-54.5-.1v32.2h54.5v-.1c4.8-.6 8.5-7.6 8.5-16 0-8.5-3.8-15.4-8.5-16zm-11.1 24h-32.2v-12h32.2c2.8.2 5 2.8 5 6 0 3.1-2.2 5.7-5 6z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "brazzers_svg__x",
    gradientUnits: "userSpaceOnUse",
    x1: 618.677,
    y1: 43,
    x2: 618.677,
    y2: 74
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#brazzers_svg__x)",
    d: "M600.8 33.5h35.8v10.8h-35.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brazzers_svg__y",
    gradientUnits: "userSpaceOnUse",
    x1: 618.677,
    y1: 43,
    x2: 618.677,
    y2: 74
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#brazzers_svg__y)",
    d: "M600.8 56.5h35.8v10.8h-35.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brazzers_svg__z",
    gradientUnits: "userSpaceOnUse",
    x1: 616.475,
    y1: 43,
    x2: 616.475,
    y2: 74
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#brazzers_svg__z)",
    d: "M596.4 79.8h40.2v10.8h-40.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brazzers_svg__A",
    gradientUnits: "userSpaceOnUse",
    x1: 631.442,
    y1: 43,
    x2: 631.442,
    y2: 74
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#brazzers_svg__A)",
    d: "M637.4 56.5c-2.2 0-4.3.7-6 1.9 2.7 1.9 4.5 5 4.5 8.6v13.2c0 3.5-1.8 6.7-4.5 8.6 1.7 1.2 3.8 1.9 6 1.9 5.8 0 10.5-4.7 10.5-10.5V67c0-5.8-4.7-10.5-10.5-10.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brazzers_svg__B",
    gradientUnits: "userSpaceOnUse",
    x1: 605.834,
    y1: 43,
    x2: 605.834,
    y2: 74
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#brazzers_svg__B)",
    d: "M601.4 56.9v-13c0-3.5 1.8-6.6 4.4-8.5-1.7-1.2-3.7-1.9-6-1.9-5.7 0-10.4 4.6-10.4 10.4V57c0 5.7 4.7 10.4 10.4 10.4 2.2 0 4.3-.7 6-1.9-2.6-2-4.4-5.1-4.4-8.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brazzers_svg__C",
    gradientUnits: "userSpaceOnUse",
    x1: 593.995,
    y1: 43,
    x2: 593.995,
    y2: 74
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#brazzers_svg__C)",
    d: "M597.7 80.1v-5.5h-11.9v5.5c0 5.7 4.6 10.4 10.4 10.4 2.2 0 4.3-.7 6-1.9-2.7-1.9-4.5-5-4.5-8.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brazzers_svg__D",
    gradientUnits: "userSpaceOnUse",
    x1: 640.037,
    y1: 43,
    x2: 640.037,
    y2: 74
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#brazzers_svg__D)",
    d: "M636.1 44.3V50h12.4v-5.7c0-6-4.8-10.8-10.8-10.8-2.3 0-4.4.7-6.2 2 2.8 1.9 4.6 5.1 4.6 8.8z"
  }))));
}
export default "data:image/svg+xml;base64,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";
export { SvgBrazzers as ReactComponent };